<div class="inner-page-header">
  <h3> إعدادات ال SEO</h3>
</div>
<div class="new-service-wrapper">
  <form [formGroup]="seoConfigFormGroup">
    <div class="main-card">
      <div class="form-group">
        <label for="" class="form-label">الرابط التعريفي (Slug) <span class="red">*</span></label>
        <input type="text" class="form-control" formControlName="slug" />
      </div>

      <div class="form-group">
        <label for="" class="form-label">عنوان الميتا (meta title)</label>
        <input type="text" class="form-control" formControlName="meta_title" />
      </div>

      <div class="form-group full-width">
        <label for="" class="form-label">وصف الميتا (meta description)</label>
        <div formControlName="meta_description" class="custom-height" 
          [ngxSummernote]="summerNoteConfig" 
          [class.ng-invalid]="submitted && seoConfigFormGroup.controls['meta_description'].invalid" 
          [class.ng-touched]="seoConfigFormGroup.controls['meta_description'].touched" 
          [class.submitted]="submitted">
        </div>
      </div>
    </div>

    <div class="double-action">
      <app-action-button (submitAction)="save($event)"></app-action-button>
    </div>
  </form>
</div>
